import {
  EMAIL_ACCOUNTS_API_PAGE_SIZE,
  getMyUnreadEmails,
  isEmailAccountsApiPageFull,
} from '../../../Email'
import { BIRDVIEW_UNREAD_EMAILS_FIRST_PAGE } from '../../DashboardBirdview.constants.api'

import {
  checkHasBirdviewMailboxUnread,
  getBirdviewUnreadEmailsCount,
  toBirdviewMailboxItem,
} from './useBirdviewMailboxLoaders.utils'

export function useBirdviewMailboxLoaders() {
  // TODO The widget endpoint rejects an all-items page size, so the mailboxes
  // are walked page by page until one comes back short. Drop the walk once the
  // backend can return every unread counter in a single call.
  async function getUnreadMailboxes() {
    const mailboxes = []
    let hasMorePages = true
    let page = BIRDVIEW_UNREAD_EMAILS_FIRST_PAGE

    while (hasMorePages) {
      const { data } = await getMyUnreadEmails({
        page,
        size: EMAIL_ACCOUNTS_API_PAGE_SIZE,
      })

      mailboxes.push(...data.items)
      hasMorePages = isEmailAccountsApiPageFull(data.items)
      page += 1
    }

    return mailboxes
  }

  async function getUnreadTile() {
    return { count: getBirdviewUnreadEmailsCount(await getUnreadMailboxes()) }
  }

  // TODO The prototype lists single emails and chats (sender, subject, age,
  // Reply / Open); the thread filter needs an email_account, so the card lists
  // mailboxes until a cross-account threads endpoint exists.
  async function getCommunicationSection() {
    const items = (await getUnreadMailboxes())
      .filter(checkHasBirdviewMailboxUnread)
      .map(toBirdviewMailboxItem)

    return { items, total: items.length }
  }

  return { getCommunicationSection, getUnreadTile }
}
